var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M50.232 121.912c-5.65 0-10.232 4.581-10.232 10.232v15.712c0 5.651 4.581 10.232 10.232 10.232h179.536c5.65 0 10.232-4.581 10.232-10.232v-15.712c0-5.651-4.581-10.232-10.232-10.232z"
})));
export default SvgMinus;